import React from 'react';
import { IconLibrary, ThriveIcon } from 'thrive-components';
import  '@/css/global/InformationText.scss'



const Information = ({text, style, className, icon, onClose}: {text: string | JSX.Element, className?: string, style?: any, icon?: JSX.Element, onClose?: () => void}) => (
    <section className={`information-component-wrapper ${className || ''}`} style={style} data-testid="information-component">
        {!!icon 
            ?   icon
            :   <ThriveIcon 
                    iconName={IconLibrary.ALERT_INFO}
                    color='var(--thriveCharcoal)'
                    sizeInPx='12'
                />
        }
        
        <div className='text-wrapper'>
            {text}
        </div>
        
        {!!onClose &&
            <div className='close-wrapper'>
                <button onClick={onClose} aria-label='close notification'>
                    <ThriveIcon 
                        iconName={IconLibrary.CLOSE}
                        color='var(--thriveCharcoal)'
                        sizeInPx='12'
                    />
                </button>
            </div>
        }
    </section>
)

export default Information

